<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Ordner mit SharePoint verknüpfen'" customClass="w-[720px] h-fit">
  <div bicPopupContent class="flex flex-col gap-4">
    <!-- Schritte -->
    <div class="flex flex-row items-center gap-3">
      @for (label of steps; track label; let i = $index; let last = $last) {
        <div class="flex flex-row items-center gap-2 shrink-0">
          <span class="flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold"
                [class.bg-green]="i === step" [class.text-white]="i <= step"
                [class.bg-secondary]="i < step" [class.border]="i > step" [class.border-gray-400]="i > step"
                [class.text-gray-500]="i > step">{{ i + 1 }}</span>
          <span class="text-sm" [class.text-green]="i === step" [class.text-gray-900]="i < step"
                [class.text-gray-500]="i > step">{{ label }}</span>
        </div>
        @if (!last) {
          <div class="flex-grow border-t border-gray-200"></div>
        }
      }
    </div>

    @switch (step) {
      @case (0) {
        @if (!loading && sites.length === 0) {
          <div class="flex flex-row gap-3 text-sm text-gray-500">
            <fa-icon [icon]="faCircleInfo" class="pt-0.5"></fa-icon>
            <span>Diesem Projekt ist noch keine SharePoint-Site zugeordnet. Eine Administrator*in kann das unter
              Organisation → Einstellungen → Datenquellen erledigen.</span>
          </div>
        } @else {
          <div class="flex flex-col gap-2">
            <span class="text-sm font-medium text-gray-900">Site</span>
            @for (s of sites; track s.connectionSiteId) {
              <label class="flex flex-row items-center gap-3 p-3 rounded-lg border cursor-pointer"
                     [class.border-green]="siteId === s.connectionSiteId" [class.border-gray-200]="siteId !== s.connectionSiteId">
                <input type="radio" name="site" class="text-green focus:ring-0" [checked]="siteId === s.connectionSiteId"
                       (change)="selectSite(s.connectionSiteId!)">
                <img src="assets/connectors/sharepoint.svg" alt="" class="w-5 h-5">
                <div class="flex flex-col min-w-0">
                  <span class="text-sm text-gray-900">{{ s.displayName }}</span>
                  <span class="text-xs text-gray-500 truncate">{{ s.webUrl }}</span>
                </div>
              </label>
            }
          </div>
          @if (siteId) {
            <div class="flex flex-col gap-2">
              <span class="text-sm font-medium text-gray-900">Bibliothek</span>
              @if (loading) {
                <span class="text-sm text-gray-500">Wird geladen …</span>
              }
              @for (d of drives; track d.driveId) {
                <label class="flex flex-row items-center gap-3 cursor-pointer">
                  <input type="radio" name="drive" class="text-green focus:ring-0" [checked]="driveId === d.driveId"
                         (change)="driveId = d.driveId!">
                  <span class="text-sm text-gray-900">{{ d.name }}</span>
                </label>
              }
            </div>
          }
          <span class="text-xs text-gray-500">
            Hier erscheinen nur Sites, die diesem Projekt zugeordnet sind. Fehlt eine Site? Eine Administrator*in kann
            sie unter Organisation → Einstellungen → Datenquellen dem Projekt zuordnen.
          </span>
        }
      }

      @case (1) {
        <div class="flex flex-row flex-wrap items-center gap-1 text-sm">
          @for (crumb of crumbs; track $index; let i = $index; let last = $last) {
            @if (!last) {
              <button type="button" class="text-gray-500 hover:text-gray-900" (click)="goTo(i)">{{ crumb.name }}</button>
              <span class="text-gray-400">›</span>
            } @else {
              <span class="text-gray-900 font-medium">{{ crumb.name }}</span>
            }
          }
        </div>
        <div class="flex flex-col gap-1 max-h-[320px] overflow-y-auto">
          @if (loading) {
            <span class="text-sm text-gray-500 px-3 py-2">Wird geladen …</span>
          }
          @for (folder of folders; track folder.itemId) {
            <div class="flex flex-row items-center gap-3 px-3 py-2 rounded-lg border cursor-pointer"
                 [class.border-green]="isSelected(folder)" [class.bg-gray-50]="isSelected(folder)"
                 [class.border-transparent]="!isSelected(folder)" (click)="choose(folder)">
              <fa-icon [icon]="faFolderOpen" class="text-gray-700"></fa-icon>
              <span class="text-sm text-gray-900 flex-grow truncate">{{ folder.name }}</span>
              <span class="text-sm text-gray-500 whitespace-nowrap">{{ folder.childCount ?? 0 }} Elemente</span>
              <span (click)="$event.stopPropagation()">
                <bic-button buttonType="no-border" [iconOnly]="true" ariaLabel="Ordner öffnen" title="Ordner öffnen"
                            (onClick)="open(folder)">
                  <fa-icon [icon]="faChevronRight"></fa-icon>
                </bic-button>
              </span>
            </div>
          }
          @if (!loading && folders.length === 0) {
            <span class="text-sm text-gray-500 px-3 py-2">Keine Unterordner{{ fileCount ? ' (' + fileCount + ' Dateien)' : '' }}.</span>
          }
        </div>
        @if (selected) {
          <div class="flex flex-row gap-2 text-sm text-gray-500">
            <fa-icon [icon]="faCircleInfo" class="pt-0.5"></fa-icon>
            <span>Ausgewählt: „{{ selected.name }}“ inklusive Unterordner.</span>
          </div>
        }
      }

      @case (2) {
        <bic-input [label]="'Projekt'" [value]="data.projectName" [disabled]="true" [showX]="false"></bic-input>
        <bic-input [label]="'Neuer Ordner in ' + data.parentFolderName" [placeholder]="'Name des Ordners'"
                   [(ngModel)]="targetFolderName" [maxLength]="255" [showX]="false"></bic-input>
        <div class="flex flex-col gap-2">
          <span class="text-sm font-medium text-gray-900">Dateitypen übernehmen</span>
          <div class="flex flex-row flex-wrap gap-6">
            <label class="flex flex-row items-center gap-2 cursor-pointer text-sm text-gray-900">
              <input type="checkbox" class="w-4 h-4 !text-green rounded border-gray-300 focus:ring-[none]" [(ngModel)]="pdf"> PDF
            </label>
            <label class="flex flex-row items-center gap-2 cursor-pointer text-sm text-gray-900">
              <input type="checkbox" class="w-4 h-4 !text-green rounded border-gray-300 focus:ring-[none]" [(ngModel)]="ifc"> IFC
            </label>
            <label class="flex flex-row items-center gap-2 cursor-pointer text-sm text-gray-900">
              <input type="checkbox" class="w-4 h-4 !text-green rounded border-gray-300 focus:ring-[none]" [(ngModel)]="office"> Office (XLSX, DOCX, PPTX)
            </label>
          </div>
        </div>
        <div class="flex flex-row gap-2 text-sm text-gray-500">
          <fa-icon [icon]="faCircleInfo" class="pt-0.5"></fa-icon>
          <span>Übernommene Dateien sind in planBIC schreibgeschützt. Umbenennen, Verschieben und Löschen erfolgen
            weiterhin in SharePoint. Quelle: {{ site?.displayName }} › {{ selected?.name }}</span>
        </div>
      }
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    @if (step > 0) {
      <bic-button buttonType="white" [disabled]="busy" (onClick)="back()">
        <fa-icon [icon]="faChevronLeft" class="pr-2"></fa-icon>Zurück
      </bic-button>
    } @else {
      <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    }
    @if (step < 2) {
      <bic-button [disabled]="!canContinue || loading" (onClick)="next()">
        Weiter<fa-icon [icon]="faChevronRight" class="pl-2"></fa-icon>
      </bic-button>
    } @else {
      <bic-button [loading]="busy" [disabled]="!canContinue || busy" (onClick)="next()">
        <fa-icon [icon]="faLink" class="pr-2"></fa-icon>Verknüpfen & synchronisieren
      </bic-button>
    }
  </div>
</bic-popup>
